import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { KYMW9006Model } from "./kymw9006.model";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";
import { UpdatePasswordService } from "./api-services/update-password.service";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";

/**
 * パスワード変更画面
 *
 * @export KYMW9006Component
 * @class KYMW9006Component
 */
@Component({
  selector: 'app-kymw9006',
  templateUrl: 'kymw9006.component.html',
  styleUrls: ['kymw9006.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9006Component extends PlessViewHelperSub implements OnInit {
  kymw9006Model: KYMW9006Model = new KYMW9006Model();

  @ViewChild('txti_Password', { static: true }) txti_Password: ElementRef;
  @ViewChild('txti_NewPassword', { static: true }) txti_NewPassword: ElementRef;
  @ViewChild('txti_ReNewPassword', { static: true }) txti_ReNewPassword: ElementRef;

  /** パスワード表示アイコン */
  iconEye = faEye;
  /** パスワード非表示アイコン */
  iconEyeSlash = faEyeSlash;
  /** アイコン変更用（現在のパスワード） 初期値：非表示 */
  iconEyeDisp1: any = this.iconEyeSlash;
  /** アイコン変更用（新しいパスワード） 初期値：非表示 */
  iconEyeDisp2: any = this.iconEyeSlash;
  /** アイコン変更用（新しいパスワード(確認)） 初期値：非表示 */
  iconEyeDisp3: any = this.iconEyeSlash;

  /** パスワード表示制御用 （現在のパスワード）初期値：非表示(●) */
  isPasswordVisible1: boolean = <boolean>false;
  /** パスワード表示制御用 （新しいパスワード）初期値：非表示(●) */
  isPasswordVisible2: boolean = <boolean>false;
  /** パスワード表示制御用 （新しいパスワード(確認)）初期値：非表示(●) */
  isPasswordVisible3: boolean = <boolean>false;

  /**
   * Creates an instance of KYMW9000Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @memberof KYMW9004Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private updatePasswordService: UpdatePasswordService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW9006';
    this.kymw9006Model.kymw9006Component = this;

    this.txti_Password.nativeElement.focus();
  }

  /**
   * 目アイコン押下時
   * フォーカス制御、アイコン変更、テキスト表示制御
   * 
   * @param event 
   * @param btnCheck 1:現在のパスワード、2:新しいパスワード、3:新しいパスワード(確認)
   */
  public eventEye_MouseDownHandler(event: MouseEvent, btnCheck: any) {
    event.preventDefault();
    
    // 「現在のパスワード」入力欄の時
    if (btnCheck === 1) {
      this.txti_Password.nativeElement.focus();
      if (this.isPasswordVisible1) {
        this.iconEyeDisp1 = faEyeSlash;
      } else {
        this.iconEyeDisp1 = faEye;
      }
      this.isPasswordVisible1 = !this.isPasswordVisible1;

    } else if (btnCheck === 2) {
      // 「新しいパスワード」入力欄の時
      this.txti_NewPassword.nativeElement.focus();
      if (this.isPasswordVisible2) {
        this.iconEyeDisp2 = faEyeSlash;
      } else {
        this.iconEyeDisp2 = faEye;
      }
      this.isPasswordVisible2 = !this.isPasswordVisible2;
      
    } else {
      // 「新しいパスワード(確認)」入力欄の時
      this.txti_ReNewPassword.nativeElement.focus();
      if (this.isPasswordVisible3) {
        this.iconEyeDisp3 = faEyeSlash;
      } else {
        this.iconEyeDisp3 = faEye;
      }
      this.isPasswordVisible3 = !this.isPasswordVisible3;
    }
  }

  /**
   * 更新ボタン押下時
   * 
   */
  public eventUpdate_CLICKHandler(): void {
    // 入力必須チェック
    if ( PlessViewUtilsSub.isEmpty( this.kymw9006Model.password ) ) {
      this.dialogService.openAlertGetMessage('W0001', ['現在のパスワード']);
      return
    }
    if ( PlessViewUtilsSub.isEmpty( this.kymw9006Model.newPassword ) ) {
      this.dialogService.openAlertGetMessage('W0001', ['新しいパスワード']);
      return
    }
    if( PlessViewUtilsSub.isEmpty( this.kymw9006Model.reNewPassword) ) {
      this.dialogService.openAlertGetMessage('W0001', ['新しいパスワード(確認)']);
      return
    }

    //8桁チェック
    if ( this.kymw9006Model.password.length < 8 ) {
      this.dialogService.openAlertGetMessage('W0006', ['現在のパスワード', '8'])
      return
    } 
    if ( this.kymw9006Model.newPassword.length < 8 ) {
      this.dialogService.openAlertGetMessage('W0006', ['新しいパスワード', '8']);
      return
    }
    if ( this.kymw9006Model.reNewPassword.length < 8 ) {
      this.dialogService.openAlertGetMessage('W0006', ['新しいパスワード(確認)', '8']);
      return
    }

    // 現在のパスワードと新しいパスワードの不一致かのチェック
    if (this.kymw9006Model.password === this.kymw9006Model.newPassword) {
      this.dialogService.openAlertGetMessage('W0057');
      return
    }

    // 新しいパスワードと新しいパスワード(確認用)の一致チェック
    if(this.kymw9006Model.newPassword !== this.kymw9006Model.reNewPassword) {
      this.dialogService.openAlertGetMessage('W0058');
      return
    }
    
    // 文字種チェック
    const mark = /[\^\$\*\.\[\]\{\}\(\)\?"!@#%&\/\\,><':;|_~`=\+\-]/;
    if ( !/^[a-zA-Z0-9\^\$\*\.\[\]\{\}\(\)\?"!@#%&\/\\,><':;|_~`=\+\-]+$/.test(this.kymw9006Model.newPassword) ||   // 4種類以外の文字を含むかチェック
         !/[a-z]/.test(this.kymw9006Model.newPassword) ||                                                           // 英小文字チェック
         !/[A-Z]/.test(this.kymw9006Model.newPassword) ||                                                           // 英大文字チェック
         !/[0-9]/.test(this.kymw9006Model.newPassword) ||                                                           // 数字チェック
         !mark.test(this.kymw9006Model.newPassword)) {                                                              // 記号チェック
      this.dialogService.openAlertGetMessage('W0059');
      return
    } 

    // 確認アラート
    this.dialogService.openAlertGetMessage('Q0194', [], (closeDetail)=>{
      if (closeDetail === PlessAlert.Yes) {
        // OK押されたらuserId取得
        this.kymw9006Model.userId = this.kymw00Model.kymw1001Model.loginUserInfo.UserID;

        // パスワード変更API
        this.updatePasswordService.execute(this.kymw9006Model, () => {
          this.dialogService.openAlertGetMessage("I0505", ['パスワード'], 
            (closeDetail: any): void => {
              if (closeDetail === PlessAlert.Yes) {
                // ダイアログを閉じる
                this.onClickClose();
              }
            }
          );
        });
      }
    });
  }
}
